module.exports = __webpack_public_path__ + "img/download.e4a1bf44.svg";